import { Link } from "react-router-dom";
import { FaPlay } from "react-icons/fa";

export default function ToSearchButton({ white }) {
    return <div className="arrow-container" style={{backgroundColor:"rgba(30, 40, 73, 1)"}}>
        <Link style={{ color: (white ? "white" : "black") }} to="/search"><h4 style={{ color: "black!important", fontSize: "14px" }} className="pointer ml-3">BEKIJK ALLE PROJECTEN <FaPlay size="12" /> </h4> </Link>
        <hr className="top-hr text-left mb-0 ml-3" />
        <hr className="top-hr-1 text-left mt-0 ml-3" />
    </div >
}